import { Typography } from '@mui/material';
import { CenterChildren } from '#features/common/components/CenterChildren';

/**
 * Shown when a desktop landing window is redirected to the app root after
 * authentication. Prevents the full web shell from flashing while the desktop
 * auth flow closes the window.
 */
export const DesktopRedirecting = () => (
  <CenterChildren>
    <Typography>Redirecting…</Typography>
  </CenterChildren>
);
